import panorama from "../../img/Odesa/Pnorama1.jpg";
import panorama2 from "../../img/Odesa/Panorama2.jpg";
import hol4 from "../../img/Odesa/hol-4.jpeg";
import hol5 from "../../img/Odesa/hol-5.jpeg";
import hol6 from "../../img/Odesa/hol-6.jpeg";
import spalnq3 from "../../img/Odesa/spalnq-3.jpeg";
import spalnq4 from "../../img/Odesa/spalnq-4.jpeg";
import spalnq5 from "../../img/Odesa/spalnq-5.jpeg";
import banq from "../../img/Odesa/bathroom.jpeg";
import terasa from "../../img/Odesa/terasa.jpg";

export const OdesaPhotos = [
    { image: panorama,  alt: "Панорама Одеса" },
    { image: panorama2, alt: "Панорама Одеса" },
    { image: hol4,      alt: "Хол" },
    { image: hol5,      alt: "Хол" },
    { image: hol6,      alt: "Хол" },
    { image: spalnq3,   alt: "Спалня" },
    { image: spalnq4,   alt: "Спалня" },
    { image: spalnq5,   alt: "Спалня" },
    { image: banq,      alt: "Баня" },
    { image: terasa,    alt: "Тераса" },
]
